import $ from "jquery"
import TemplateView from "../../TemplateView"
import SearchField from "../SearchField"
import EditButton from "../EditButton"
import ViewModeSelector from "./ViewModeSelector"
import {
    setEventPreventHidingCreateTaskSlidingPanel,
    setEventPreventHidingEditCustomerSlidingPanel,
    setEventPreventHidingEditProjectSlidingPanel
} from "../../panels/utils"
import {connect} from "../../redux/utils"
import {bindActionCreators} from 'redux'
import {
    canManageSelectedProject,
    getSingleCPSelection, getTaskStatusFilter,
    getViewMode,
    isNeedToShowScopeFilter, isNeedToShowSelection,
    isSelectedProjectArchived,
    isShowOnlyManageableTasks,
    isShowViewMode,
    isViewerHasManageableTasks
} from "../common/selectors"
import ScopeFilter from "./ScopeFilter"
import {setShowOnlyManageableTasks, switchViewMode} from "../common/actions"
import {getHeaderTitle, isShowArchivedLabel} from './selectors'
import {openCreateTaskPanel} from '../../panels/task/createPanel/actions'
import Button from '../../components/Button'
import messageResource from '../../messageResource'
import FiltersPanelContainer from '../FiltersPanelContainer'
import {changeAllTasksSelectedAction, collapseAllProjects, toggleMinimizedCards} from '../kanban/actions'
import {doesIgnoreCollapse, getCollapsedProjectsWithIdsSet, isMinimizedCards} from '../kanban/selectors'
import {getWorkflowStatuses as getWorkflowStatusesMap} from '../../entities/selectors'
import {isAllTasksSelectedCheckboxChecked} from '../taskSelection/selectors'

// TODO: Make this view better. Replace event triggers with callbacks, introduce state.

class HeaderPanel extends TemplateView {
    constructor({
        setShowOnlyManageableTasks = () => {},
        switchViewMode = () => {},
        openCreateTaskPanel = () => {},
        onAllSelectedChanged = allSelected => {},
        onMinimizedCardsChanged = minimizedCards => {},
        onCollapseAllChanged = isAllCollapsed => {},
    }) {
        super();

        this.actions = {
            setShowOnlyManageableTasks,
            switchViewMode,
            openCreateTaskPanel,
        }

        this.callbacks = {
            onAllSelectedChanged,
            onMinimizedCardsChanged,
            onCollapseAllChanged,
        }

        this.state = {
            canManageSelectedProject: false,
            isSelectedProjectArchived: false,
            hasManageableTasks: false,
            needToShowScopeFilter: false,
            showOnlyManageableTasks: false,
            viewMode: null,
            singleCPSelection: {},
            headerTitle: '',
            showArchivedLabel: false,
            showViewModeSelector: false,
            allTasksSelected: false,
            collapsedProjects: {
                all: false,
                idsSet: {},
            },
            taskStatusFilter: {
                allSelected: true,
                statusTypes: [],
                statusIds: []
            },
            workflowStatusesMap: {},
            minimizedCards: false,
            showSelection: false,
            ignoreProjectCollapse : false,
        }

        this.onStatePropertyChanged('ignoreProjectCollapse', ignoreProjectCollapse => this.filtersPanelContainer.setState({ignoreProjectCollapse}))

        this.onStatePropertyChanged('showOnlyManageableTasks', showOnlyManageableTasks => this.scopeFilter.setState({showOnlyManageableTasks}))
        this.onStatePropertyChanged('showViewModeSelector', show => {
            this.viewModeSelector.toggle(show)
        })
        this.onStatePropertyChanged('viewMode', viewMode => this.viewModeSelector.setState({viewMode}))
        this.onAnyStatePropertyChanged(['singleCPSelection', 'headerTitle'], () => this.updateNavigation())
        this.onStatePropertyChanged('showArchivedLabel', show => this.$archivedLabel.toggleClass('invisible', !show))

        this.onAnyStatePropertyChanged(['canManageSelectedProject', 'singleCPSelection', 'isSelectedProjectArchived'],
            ({canManageSelectedProject, singleCPSelection, isSelectedProjectArchived}) => {
                const canAddTask = canManageSelectedProject && !!singleCPSelection.projectId && !!singleCPSelection.customerId
                this.addNewTaskButton.toggle(canAddTask)

                this.addNewTaskButton.setState({
                    disabled: canAddTask && isSelectedProjectArchived,
                    disableTooltipText: messageResource.getMessage("task.list.add_new_task.disable_tooltip.project_archived")
                })
        })

        this.onAnyStatePropertyChanged(['hasManageableTasks', 'needToShowScopeFilter'], state => {
            this.scopeFilter.toggle(state.needToShowScopeFilter)
            this.workScopeLabel.toggleClass("visible", !state.needToShowScopeFilter && !state.hasManageableTasks)
            this.manageScopeLabel.toggleClass("visible", !state.needToShowScopeFilter && state.hasManageableTasks)
        })

        this.onAnyStatePropertyChanged(
            ['viewMode', 'allTasksSelected', 'collapsedProjects', 'taskStatusFilter', 'workflowStatusesMap', 'minimizedCards', 'showSelection', 'singleCPSelection'],
            state => {
                this.filtersPanelContainer.setState(state)
            }
        )
    }

    templateHtml() {
        return "<div class='taskManagementHeaderPanel'>" +
               "  <div class='archivedTaskHeaderLabel'><%=archived%></div>" +
               "  <div class='topContainer'>" +
               "      <div class='leftContainer'>" +
               "        <div class='titleEditButtonContainer'>" +
               "            <div class='title'></div>" +
               "        </div>" +
               "      </div>" +
               "      <div class='rightContainer'>" +
               "        <div class='searchFieldContainer'></div>" +
               "      </div>" +
               "  </div>" +
               "  <div class='downContainer'>" +
               "      <div class='scopeAccessContainer'>" +
               "        <div class='scopeAccessFilter'/>" +
               "        <span class='workScopeLabel'><%-workScopeLabel%></span>" +
               "        <span class='manageScopeLabel'><%-manageScopeLabel%></span>" +
               "      </div>" +
               "      <div class='downRightSubpanel'>" +
               "        <div class='filtersPanelContainer'></div>" +
               "        <div class='viewModeSelectorContainer'></div>" +
               "      </div>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        this.scopeFilter = new ScopeFilter({
            onShowOnlyManageableTasksChange: this.actions.setShowOnlyManageableTasks
        }).init(this.find('.scopeAccessFilter'))
        this.workScopeLabel = this.find('.workScopeLabel')
        this.manageScopeLabel = this.find('.manageScopeLabel')

        const $viewModeSelectorContainer = this.find(".viewModeSelectorContainer");
        this.viewModeSelector = new ViewModeSelector({
            onModeSelected: this.actions.switchViewMode
        }).init($viewModeSelectorContainer);

        const $searchFieldContainer = this.find(".searchFieldContainer")
        new SearchField({
            onFieldChange: (text) => $(document).trigger("taskManagement_tasksTable_tasksSearchField_change", [text])
        }).init($searchFieldContainer);

        new EditButton(this.find(".titleEditButtonContainer") , e => this._editButtonClickHandler(e)).init();

        this.addNewTaskButton = new Button({
            additionalClass: "addNewTaskButton",
            withPlusIcon: true,
            label: messageResource.getMessage("task.list.add_new_task"),
            onClickCb: (e) => {
                setEventPreventHidingCreateTaskSlidingPanel(e)
                this.actions.openCreateTaskPanel()},
            withDisableTooltip: true,
        }).init(this.find(".rightContainer"))

        this.$title = this.find(".leftContainer").find(".title");

        this.$archivedLabel = this.find(".archivedTaskHeaderLabel")

        this.filtersPanelContainer = new FiltersPanelContainer({
            onAllSelectedChanged: this.callbacks.onAllSelectedChanged,
            onMinimizedCardsChanged: this.callbacks.onMinimizedCardsChanged,
            onCollapseAllChanged: this.callbacks.onCollapseAllChanged,
        }).init(this.find('.filtersPanelContainer'))
    }

    messageKeys() {
        return {
            archived: "task.list.header.archived",
            tasksOf: "task.list.tasks_of",
            allCustomers: "task.list.all_customers",
            workScopeLabel: "task.list.header.type_filter.my_tasks",
            manageScopeLabel: 'task.list.header.type_filter.tasks_can_manage'
        }
    }

    updateNavigation() {
        this.$title.text(this.state.headerTitle);
        this.$title.attr('title', this.state.headerTitle)
        this.$el.toggleClass("hasSelectedCustomer", !!this.state.singleCPSelection.customerId);
        this.$el.toggleClass("hasSelectedProject", !!this.state.singleCPSelection.projectId);
    }

    _editButtonClickHandler(e) {
        const selection = this.state.singleCPSelection;
        if (selection.projectId) {
            setEventPreventHidingEditProjectSlidingPanel(e)
            $(document).trigger("taskManagement_customersProjectsPanel_viewProject", selection.projectId);
        } else if (selection.customerId) {
            setEventPreventHidingEditCustomerSlidingPanel(e)
            $(document).trigger("taskManagement_viewCustomer", selection.customerId);
        }
    }
}

export default connect(
    state => ({
        canManageSelectedProject: canManageSelectedProject(state),
        isSelectedProjectArchived: isSelectedProjectArchived(state),
        hasManageableTasks: isViewerHasManageableTasks(state),
        needToShowScopeFilter: isNeedToShowScopeFilter(state),
        showOnlyManageableTasks: isShowOnlyManageableTasks(state),
        viewMode: getViewMode(state),
        singleCPSelection: getSingleCPSelection(state),
        headerTitle: getHeaderTitle(state),
        showArchivedLabel: isShowArchivedLabel(state),
        showViewModeSelector: isShowViewMode(state),
        allTasksSelected: isAllTasksSelectedCheckboxChecked(state),
        taskStatusFilter: getTaskStatusFilter(state),
        workflowStatusesMap: getWorkflowStatusesMap(state),
        minimizedCards: isMinimizedCards(state),
        showSelection: isNeedToShowSelection(state),
        collapsedProjects: getCollapsedProjectsWithIdsSet(state),
        ignoreProjectCollapse: doesIgnoreCollapse(state),
    }),
    dispatch => ({
        setShowOnlyManageableTasks: bindActionCreators(setShowOnlyManageableTasks, dispatch),
        switchViewMode: bindActionCreators(switchViewMode, dispatch),
        openCreateTaskPanel: bindActionCreators(openCreateTaskPanel, dispatch),
        onAllSelectedChanged: bindActionCreators(changeAllTasksSelectedAction, dispatch),
        onMinimizedCardsChanged: bindActionCreators(toggleMinimizedCards, dispatch),
        onCollapseAllChanged: bindActionCreators(collapseAllProjects, dispatch),
    }),
)(HeaderPanel)



// WEBPACK FOOTER //
// ./web/js/taskManagement/header/HeaderPanel.js